import type {UILayout} from 'swayok-react-mdb-ui-kit/types/Common'
import {
    useAccountFlagsStore,
    useUiLayoutStore,
} from '../../../../../stores'
import {GetAdvancePromoCard} from '../../../../layout/promo_cards/GetAdvancePromoCard'
import {PromoteYourAdsPromoCard} from '../../../../layout/promo_cards/PromoteYourAdsPromoCard'
import {RepayAdvanceAfterSellPromoCard} from '../../../../layout/promo_cards/RepayAdvanceAfterSellPromoCard'

interface AdsListPromoBannerProps {
    listUid: string
    sideMenuVisibleFromBsBreakpoint?: UILayout['bootstrapSize']
}

// Промо-баннеры для списка объявлений.
export function AdsListPromoBanners(props: AdsListPromoBannerProps) {
    const {
        listUid,
        sideMenuVisibleFromBsBreakpoint = 'lg',
    } = props

    const isSeller: boolean = useAccountFlagsStore(
        state => state.isSeller
    )

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    const utmSource = listUid + '_items_list'
    const bannerSize = getBannerSize(bootstrapSize, sideMenuVisibleFromBsBreakpoint)

    if (!isSeller) {
        switch (bootstrapSize) {
            case 'xxs':
            case 'xs':
            case 'sm':
                return (
                    <div
                        style={{
                            order: 31,
                        }}
                    >
                        <PromoteYourAdsPromoCard
                            className="inside-items-list"
                            utmSource={utmSource}
                            size={bannerSize}
                        />
                    </div>
                )
            default:
                return null
        }
    }

    return (
        <div
            className="d-grid grid-columns-1 grid-columns-md-2 gap-medium"
            style={{
                order: 31,
            }}
        >
            <GetAdvancePromoCard
                className="inside-items-list"
                utmSource={utmSource}
                size={bannerSize}
            />
            <RepayAdvanceAfterSellPromoCard
                className="inside-items-list"
                utmSource={utmSource}
                size={bannerSize}
            />
        </div>
    )
}

// Получить размер баннера для сетки объявлений.
function getBannerSize(
    bsScreenSize: UILayout['bootstrapSize'],
    _sideMenuVisibleFromBsBreakpoint: UILayout['bootstrapSize']
): 'sm' | 'md' | 'lg' {
    return bsScreenSize === 'lg' || bsScreenSize === 'xl' || bsScreenSize === 'xxl'
        ? 'md'
        : 'sm'
}
